/**
 * Helpers purs pour les miniatures d’archives (liste replays).
 */

/** True si une vignette persistée peut être affichée sans WebGL. */
export function hasStoredArchivePreview(path: string | null | undefined): boolean {
  if (typeof path !== 'string') return false;
  const trimmed = path.trim();
  return trimmed.length > 0 && (trimmed.startsWith('/') || trimmed.startsWith('http'));
}

/** Convertit un data URL PNG/JPEG/WebP en Blob pour upload multipart. */
export function dataUrlToImageBlob(dataUrl: string): Blob | null {
  const match = /^data:([a-zA-Z0-9/+.-]+);base64,([A-Za-z0-9+/=]+)$/.exec(dataUrl.trim());
  if (!match) return null;
  const mime = match[1];
  if (!mime.startsWith('image/')) return null;
  try {
    const binary = atob(match[2]);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return new Blob([bytes], { type: mime });
  } catch {
    return null;
  }
}

/** Extension fichier à partir du type MIME (défaut .png). */
export function imageMimeToExt(mime: string): '.png' | '.jpg' | '.webp' {
  if (mime === 'image/jpeg' || mime === 'image/jpg') return '.jpg';
  if (mime === 'image/webp') return '.webp';
  return '.png';
}
